import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setSoftwareDevelopmentPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const useSoftwareDevelopmentSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getSoftwareDevelopmentSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.software_development_page?.software_development_section}`);
      console.log("🚀 ~ getSoftwareDevelopmentSectionJson ~ data:", response);
      console.log("🚀 ~ getSoftwareDevelopmentSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setSoftwareDevelopmentPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error Fetching Software Development section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getSoftwareDevelopmentSectionJson();
  }, [getSoftwareDevelopmentSectionJson]);

  return {
    data,
    loading,
    error,
    getSoftwareDevelopmentSectionJson,
    fetchOnMount,
    refetch: getSoftwareDevelopmentSectionJson
  };
};

export default useSoftwareDevelopmentSection;
